module.exports = __webpack_public_path__ + "img/jcb.d57323dc.svg";